import { render, staticRenderFns } from "./VendingsTitle.vue?vue&type=template&id=2be61350&scoped=true"
import script from "./VendingsTitle.vue?vue&type=script&lang=js"
export * from "./VendingsTitle.vue?vue&type=script&lang=js"
import style0 from "./VendingsTitle.vue?vue&type=style&index=0&id=2be61350&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be61350",
  null
  
)

export default component.exports